module.exports = __webpack_public_path__ + "img/img_2.c33e3033.png";